/**
 * Splide
 */

import Splide from '@splidejs/splide';

// MV
export function mvSplide() {
  document.addEventListener( 'DOMContentLoaded', function() {

    var splideElement = document.querySelector('.splide');

    if (splideElement) {
      var splide = new Splide( '.splide', {
        autoplay: true,
        type: "loop",
        pauseOnHover: true,
        pauseOnFocus: true,
        interval: 6000,
        speed: 600,
        padding: "20%",
        gap: 10,
        breakpoints: {
          600: {
            perPage: 1,
            padding: 0,
          },
        }
      } );
      splide.mount();
    }
  });

}
